import {Injectable} from "@angular/core";
import {RegisterFormModel} from "../models/register-form.model";

import 'firebase/auth';
import * as firebase from 'firebase/app';
import {BehaviorSubject, from, of} from "rxjs";
import {catchError, last, map, switchMap, tap} from "rxjs/operators";
import {AngularFirestore} from "@angular/fire/firestore";
import {User} from "../models/user.model";
import {Court} from "../models/court";
import {AngularFireStorage} from "@angular/fire/storage";
import { AlertToastService } from "./toast.service";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  readonly auth: firebase.auth.Auth = firebase.auth();

  public user: User;

  public user$: BehaviorSubject<User> = new BehaviorSubject<User>(null);

  constructor(
    private afs: AngularFirestore,
    private storage: AngularFireStorage,
    private alertToastService: AlertToastService,
  ) {
    this.auth.onAuthStateChanged((user) => {
      if (user) {
        this.afs.doc<User>(`users/${user.uid}`).get()
          .subscribe(data => {
            if (data.exists) {
              this.user = data.data() as User;
              this.user$.next(this.user);
            } else {
              // this.logout();
              // this.alertToastService.pushError('Ваш аккаунт видалено');
            }
          });
      }
    });
  }

  register(registerForm: RegisterFormModel & User, avatar: Blob) {
    return from(this.auth.createUserWithEmailAndPassword(registerForm.email, registerForm.password))
      .pipe(
        switchMap(data => {
          delete registerForm.password;
          registerForm.uid = data.user.uid;
          if (avatar) {
            const filePath = `users/${registerForm.uid}`;
            const fileRef = this.storage.ref(filePath);
            const task = this.storage.upload(filePath, avatar);
            return task.snapshotChanges().pipe(
              last(),
              switchMap(() => fileRef.getDownloadURL()),
              switchMap(data => {
                registerForm.avatarUrl = data;
                return from(this.afs.doc<User>(`users/${registerForm.uid}`).set(registerForm));
              })
            );
          } else {
            return this.afs.doc<User>(`users/${registerForm.uid}`).set(registerForm);
          }
        }),
      );
  }

  login(loginForm: { email, password }) {
    return from(this.auth.signInWithEmailAndPassword(loginForm.email, loginForm.password));
  }

  logout() {
    this.user = null;
    this.user$.next(null);
    return from(this.auth.signOut());
  }

  updateProfile(userId: string, user: User, avatar?: Blob) {
    if (avatar) {
      const filePath = `users/${userId}`;
      const fileRef = this.storage.ref(filePath);
      const task = this.storage.upload(filePath, avatar);
      return task.snapshotChanges().pipe(
        last(),
        switchMap(() => fileRef.getDownloadURL()),
        switchMap(data => {
          user.avatarUrl = data;
          return from(this.afs.doc(`users/${userId}`).update({...user}))
            .pipe(tap(() => {
              Object.assign(this.user, user);
            }));
        })
      );
    } else {
      return from(this.afs.doc(`users/${userId}`).update({...user}))
        .pipe(tap(() => {
          Object.assign(this.user, user);
        }));
    }

  }

  confirmPolicy(userId: string) {
    return from(this.afs.doc(`users/${userId}`).update({ confirmPolicy: true}));
  }

  setTelegramGroupPopupShowed(userId: string) {
    return from(this.afs.doc(`users/${userId}`).update({ telegramGroupPopupShowed: true}));
  }

  recoverPassword(email: string) {
    return from(this.auth.sendPasswordResetEmail(email));
  }

  removeUser(userId: string) {
    return from(this.afs.doc(`users/${userId}`).delete());
  }
}
